export { default } from './Component.tsx'
